/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { MobileAppLockSettings } from '../models/mobileAppLockSettings';

import type { ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate } from '../models/modulesUserManagementApiSettingsRoutesSysadminSettingsUpdate';

import type { ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate } from '../models/modulesUserManagementApiSettingsRoutesTenantSettingsUpdate';

import type { NotificationSettingsResponse } from '../models/notificationSettingsResponse';

import type { NotificationSettingsUpdate } from '../models/notificationSettingsUpdate';

import type { UserManagementUserSettingsUpdate } from '../models/userManagementUserSettingsUpdate';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get tenant's user management settings. Requires admin.
 * @summary Get Tenant Settings
 */
export const getTenantSettingsApiV1UserManagementSettingsTenantGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/tenant`,
    method: 'GET',
    signal
  });
};

export const getGetTenantSettingsApiV1UserManagementSettingsTenantGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/tenant`] as const;
  };

export const getGetTenantSettingsApiV1UserManagementSettingsTenantGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantSettingsApiV1UserManagementSettingsTenantGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
      >
    > = ({ signal }) =>
      getTenantSettingsApiV1UserManagementSettingsTenantGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantSettingsApiV1UserManagementSettingsTenantGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
    >
  >;
export type GetTenantSettingsApiV1UserManagementSettingsTenantGetQueryError =
  unknown;

export function useGetTenantSettingsApiV1UserManagementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantSettingsApiV1UserManagementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantSettingsApiV1UserManagementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Settings
 */

export function useGetTenantSettingsApiV1UserManagementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1UserManagementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1UserManagementSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantSettingsApiV1UserManagementSettingsTenantGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant's user management settings. Requires admin.
 * @summary Update Tenant Settings
 */
export const updateTenantSettingsApiV1UserManagementSettingsTenantPut = (
  modulesUserManagementApiSettingsRoutesTenantSettingsUpdate: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/tenant`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesUserManagementApiSettingsRoutesTenantSettingsUpdate
  });
};

export const getUpdateTenantSettingsApiV1UserManagementSettingsTenantPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut
        >
      >,
      TError,
      { data: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut
      >
    >,
    TError,
    { data: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTenantSettingsApiV1UserManagementSettingsTenantPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut
        >
      >,
      { data: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateTenantSettingsApiV1UserManagementSettingsTenantPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantSettingsApiV1UserManagementSettingsTenantPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut
      >
    >
  >;
export type UpdateTenantSettingsApiV1UserManagementSettingsTenantPutMutationBody =
  ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate;
export type UpdateTenantSettingsApiV1UserManagementSettingsTenantPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Settings
 */
export const useUpdateTenantSettingsApiV1UserManagementSettingsTenantPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut
        >
      >,
      TError,
      { data: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTenantSettingsApiV1UserManagementSettingsTenantPut>
  >,
  TError,
  { data: ModulesUserManagementApiSettingsRoutesTenantSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantSettingsApiV1UserManagementSettingsTenantPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check if current user can invite other users.
 * @summary Check Can Invite
 */
export const checkCanInviteApiV1UserManagementSettingsCanInviteGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/can-invite`,
    method: 'GET',
    signal
  });
};

export const getCheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/can-invite`] as const;
  };

export const getCheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
      >
    > = ({ signal }) =>
      checkCanInviteApiV1UserManagementSettingsCanInviteGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
    >
  >;
export type CheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryError =
  unknown;

export function useCheckCanInviteApiV1UserManagementSettingsCanInviteGet<
  TData = Awaited<
    ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCheckCanInviteApiV1UserManagementSettingsCanInviteGet<
  TData = Awaited<
    ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCheckCanInviteApiV1UserManagementSettingsCanInviteGet<
  TData = Awaited<
    ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Check Can Invite
 */

export function useCheckCanInviteApiV1UserManagementSettingsCanInviteGet<
  TData = Awaited<
    ReturnType<typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof checkCanInviteApiV1UserManagementSettingsCanInviteGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCheckCanInviteApiV1UserManagementSettingsCanInviteGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get current user's notification settings.
 * @summary Get Notification Settings
 */
export const getNotificationSettingsApiV1UserManagementSettingsNotificationsGet =
  (signal?: AbortSignal) => {
    return customInstance<NotificationSettingsResponse>({
      url: `/api/v1/user-management/settings/notifications`,
      method: 'GET',
      signal
    });
  };

export const getGetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/notifications`] as const;
  };

export const getGetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
        >
      >
    > = ({ signal }) =>
      getNotificationSettingsApiV1UserManagementSettingsNotificationsGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
      >
    >
  >;
export type GetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryError =
  unknown;

export function useGetNotificationSettingsApiV1UserManagementSettingsNotificationsGet<
  TData = Awaited<
    ReturnType<
      typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetNotificationSettingsApiV1UserManagementSettingsNotificationsGet<
  TData = Awaited<
    ReturnType<
      typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetNotificationSettingsApiV1UserManagementSettingsNotificationsGet<
  TData = Awaited<
    ReturnType<
      typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Notification Settings
 */

export function useGetNotificationSettingsApiV1UserManagementSettingsNotificationsGet<
  TData = Awaited<
    ReturnType<
      typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getNotificationSettingsApiV1UserManagementSettingsNotificationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetNotificationSettingsApiV1UserManagementSettingsNotificationsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's notification settings.
 * @summary Update Notification Settings
 */
export const updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut =
  (notificationSettingsUpdate: NotificationSettingsUpdate) => {
    return customInstance<NotificationSettingsResponse>({
      url: `/api/v1/user-management/settings/notifications`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: notificationSettingsUpdate
    });
  };

export const getUpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
        >
      >,
      TError,
      { data: NotificationSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
      >
    >,
    TError,
    { data: NotificationSettingsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
        >
      >,
      { data: NotificationSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
      >
    >
  >;
export type UpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPutMutationBody =
  NotificationSettingsUpdate;
export type UpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Notification Settings
 */
export const useUpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
          >
        >,
        TError,
        { data: NotificationSettingsUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateNotificationSettingsApiV1UserManagementSettingsNotificationsPut
      >
    >,
    TError,
    { data: NotificationSettingsUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateNotificationSettingsApiV1UserManagementSettingsNotificationsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The effective mobile app-lock configuration for the calling user.

Bespoke rather than factory-generated because it is a RESOLVED view across
two tiers, and because every user must be able to read it — the tenant
settings route next to it is admin-only.
 * @summary Get Mobile App Lock Settings
 */
export const getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet =
  (signal?: AbortSignal) => {
    return customInstance<MobileAppLockSettings>({
      url: `/api/v1/user-management/settings/mobile-app-lock`,
      method: 'GET',
      signal
    });
  };

export const getGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/mobile-app-lock`] as const;
  };

export const getGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
        >
      >
    > = ({ signal }) =>
      getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
      >
    >
  >;
export type GetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryError =
  unknown;

export function useGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet<
  TData = Awaited<
    ReturnType<
      typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet<
  TData = Awaited<
    ReturnType<
      typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet<
  TData = Awaited<
    ReturnType<
      typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Mobile App Lock Settings
 */

export function useGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet<
  TData = Awaited<
    ReturnType<
      typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMobileAppLockSettingsApiV1UserManagementSettingsMobileAppLockGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get user-management sysadmin settings. Requires sysadmin.
 * @summary Get Sysadmin Settings
 */
export const getSysadminSettingsApiV1UserManagementSettingsSysadminGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/sysadmin`,
    method: 'GET',
    signal
  });
};

export const getGetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/sysadmin`] as const;
  };

export const getGetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
        >
      >
    > = ({ signal }) =>
      getSysadminSettingsApiV1UserManagementSettingsSysadminGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
      >
    >
  >;
export type GetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryError =
  unknown;

export function useGetSysadminSettingsApiV1UserManagementSettingsSysadminGet<
  TData = Awaited<
    ReturnType<typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSysadminSettingsApiV1UserManagementSettingsSysadminGet<
  TData = Awaited<
    ReturnType<typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSysadminSettingsApiV1UserManagementSettingsSysadminGet<
  TData = Awaited<
    ReturnType<typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sysadmin Settings
 */

export function useGetSysadminSettingsApiV1UserManagementSettingsSysadminGet<
  TData = Awaited<
    ReturnType<typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1UserManagementSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSysadminSettingsApiV1UserManagementSettingsSysadminGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update user-management sysadmin settings. Requires sysadmin.
 * @summary Update Sysadmin Settings
 */
export const updateSysadminSettingsApiV1UserManagementSettingsSysadminPut = (
  modulesUserManagementApiSettingsRoutesSysadminSettingsUpdate: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/sysadmin`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesUserManagementApiSettingsRoutesSysadminSettingsUpdate
  });
};

export const getUpdateSysadminSettingsApiV1UserManagementSettingsSysadminPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
        >
      >,
      TError,
      { data: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
      >
    >,
    TError,
    { data: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSysadminSettingsApiV1UserManagementSettingsSysadminPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
        >
      >,
      { data: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateSysadminSettingsApiV1UserManagementSettingsSysadminPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSysadminSettingsApiV1UserManagementSettingsSysadminPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
      >
    >
  >;
export type UpdateSysadminSettingsApiV1UserManagementSettingsSysadminPutMutationBody =
  ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate;
export type UpdateSysadminSettingsApiV1UserManagementSettingsSysadminPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Sysadmin Settings
 */
export const useUpdateSysadminSettingsApiV1UserManagementSettingsSysadminPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
        >
      >,
      TError,
      { data: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateSysadminSettingsApiV1UserManagementSettingsSysadminPut
    >
  >,
  TError,
  { data: ModulesUserManagementApiSettingsRoutesSysadminSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSysadminSettingsApiV1UserManagementSettingsSysadminPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the calling user's user-management settings.
 * @summary Get User Settings
 */
export const getUserSettingsApiV1UserManagementSettingsUserGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/user`,
    method: 'GET',
    signal
  });
};

export const getGetUserSettingsApiV1UserManagementSettingsUserGetQueryKey =
  () => {
    return [`/api/v1/user-management/settings/user`] as const;
  };

export const getGetUserSettingsApiV1UserManagementSettingsUserGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetUserSettingsApiV1UserManagementSettingsUserGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
      >
    > = ({ signal }) =>
      getUserSettingsApiV1UserManagementSettingsUserGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetUserSettingsApiV1UserManagementSettingsUserGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
    >
  >;
export type GetUserSettingsApiV1UserManagementSettingsUserGetQueryError =
  unknown;

export function useGetUserSettingsApiV1UserManagementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSettingsApiV1UserManagementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSettingsApiV1UserManagementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Settings
 */

export function useGetUserSettingsApiV1UserManagementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1UserManagementSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserSettingsApiV1UserManagementSettingsUserGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the calling user's user-management settings.
 * @summary Update User Settings
 */
export const updateUserSettingsApiV1UserManagementSettingsUserPut = (
  userManagementUserSettingsUpdate: UserManagementUserSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/user-management/settings/user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: userManagementUserSettingsUpdate
  });
};

export const getUpdateUserSettingsApiV1UserManagementSettingsUserPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
      >,
      TError,
      { data: UserManagementUserSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
    >,
    TError,
    { data: UserManagementUserSettingsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateUserSettingsApiV1UserManagementSettingsUserPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
      >,
      { data: UserManagementUserSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateUserSettingsApiV1UserManagementSettingsUserPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserSettingsApiV1UserManagementSettingsUserPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
    >
  >;
export type UpdateUserSettingsApiV1UserManagementSettingsUserPutMutationBody =
  UserManagementUserSettingsUpdate;
export type UpdateUserSettingsApiV1UserManagementSettingsUserPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Settings
 */
export const useUpdateUserSettingsApiV1UserManagementSettingsUserPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
      >,
      TError,
      { data: UserManagementUserSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateUserSettingsApiV1UserManagementSettingsUserPut>
  >,
  TError,
  { data: UserManagementUserSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateUserSettingsApiV1UserManagementSettingsUserPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
